import {
  BaseActionObject,
  DoneInvokeEvent,
  StateNodeConfig,
  assign
} from "xstate4"
import { BASE_SP_V2_PROGRESS_BY_CONTENT_PATH } from "../constants"
import { getServiceErrorMessage } from "../../helpers"
import { Context, Transitions } from "../../types"
import { StudyPlanProgressModel } from "../../../../../../types/gqlTypes/graphql"

export const getProgressBySelectedStudyPlanSubjectTransition: StateNodeConfig<
  Context,
  {},
  Transitions,
  BaseActionObject
> = {
  invoke: {
    id: "getProgressBySelectedStudyPlanSubject",
    src: "getProgressBySelectedStudyPlanSubject",
    onDone: {
      target: `${BASE_SP_V2_PROGRESS_BY_CONTENT_PATH}.idle`,
      actions: assign<Context, DoneInvokeEvent<StudyPlanProgressModel>>(
        (ctx, evt) => {
          return {
            progressBySubjectsModel: {
              [ctx.subject]: evt.data
            }
          }
        }
      )
    },
    onError: {
      target: "idle",
      actions: assign<Context, DoneInvokeEvent<any>>({
        loading: false,
        snackbar: (_ctx, evt) => ({
          message: getServiceErrorMessage(
            "getProgressBySelectedStudyPlanSubject",
            {
              errorReason: evt.data.message
            }
          ),
          withUndo: false,
          error: true
        })
      })
    }
  }
}
